export function getInvitationToken(): string | undefined {
  return (
    new URLSearchParams(window.location.search).get('invitationToken') ??
    new URLSearchParams(window.location.hash.slice(1)).get('invitationToken') ??
    undefined
  );
}
